import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  tr: {
    translation: translationTR,
  },
};

// localStorage’dan önceki dil seçimini oku, yoksa 'tr' kullan
const savedLang = localStorage.getItem('i18nextLng') || 'tr';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,            // Burada localStorage’daki dil seçimi kullanılır
    fallbackLng: 'tr',         // Eğer dil bulunamazsa Türkçe göster
    interpolation: {
      escapeValue: false,      // React zaten XSS koruması yapıyor
    },
    react: {
      useSuspense: false,      // Suspense istemiyorsan false, kullanabilirsin
      bindI18n: 'languageChanged',
    },
  });

export default i18n;
